import { INSIGHTS_DATE_RANGE } from '../types';

export const getDateGivenRange = (current: Date, range: string): Date => {
    switch (range) {
        case INSIGHTS_DATE_RANGE.LAST_6_MONTHS:
            return new Date(current.getFullYear(), current.getMonth() - 5, 1);
        case INSIGHTS_DATE_RANGE.LAST_30_DAYS:
            return new Date(current.getFullYear(), current.getMonth(), current.getDate() - 29);
        case INSIGHTS_DATE_RANGE.LAST_7_DAYS:
            return new Date(current.getFullYear(), current.getMonth(), current.getDate() - 6);
        case INSIGHTS_DATE_RANGE.YESTERDAY:
            const yesterday = new Date(current);
            yesterday.setDate(current.getDate() - 1);
            return yesterday;
        case INSIGHTS_DATE_RANGE.CUSTOM:
            return current;
        default:
            throw new Error(`Invalid range: ${range}`);
    }
};
